module.exports = __webpack_public_path__ + "img/progress_075.9929b894.png";